"use strict";

module.exports = function () {
    this.currentUrl = window.location.pathname + window.location.search;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swup/lib/modules/getUrl.js
// module id = 34
// module chunks = 0